document.addEventListener('DOMContentLoaded', function () {
  // Select all metal containers within the metal list
  const metalContainers = document.querySelectorAll('.metal-list .checkbox-metal-container');

  // Iterate over each container and add a click event listener
  metalContainers.forEach(container => {
    container.addEventListener('click', () => {
      // Get the metal type from the clicked container's attribute
      const selectedMetal = container.getAttribute('metal');
      
      // You can add your specific logic here based on the selected metal type
      console.log(`Selected metal: ${selectedMetal}`);
      
      // Example action: Adding an 'active' class to the selected container
      // Remove 'active' class from all containers first
      metalContainers.forEach(c => c.classList.remove('active'));
      // Add 'active' class to the clicked container
      container.classList.add('active');
      
      // If needed, you can also update the URL parameter or any other UI elements
    });
  });
});

$(document).on('click', '.carat_var_value', function () {    
    var $this = $(this);
    var productCardHandle = $this.attr('handle');
    var $productCard = $('product-card[handle="' + productCardHandle + '"]');
    
    var currentPrice = $this.attr('va_price');
    var comparePrice = $this.attr('va_compare_price');
    var discountPrice = $this.attr('va_discount_price');
    var salePrice = $this.attr('va_sale');
    var caratValue = parseFloat($this.attr('va_carat'));
    var sideValue = parseFloat($this.attr('va_side'));
    var variantId = $this.attr('v_id');
    
    $this.parent().find('.selected').removeClass('selected');
    $this.addClass('selected');

    var existingUrl = $productCard.find('a.product_link_carat').attr('href').split('?variant')[0];
    var newUrl = existingUrl + "?variant=" + variantId;
    
    $productCard.find('a.product_link_carat').attr('href', newUrl);
    $productCard.find('sale-price').text(currentPrice);
    $productCard.find('compare-at-price').text(comparePrice);
    $productCard.find('new-price').text(discountPrice);
    $productCard.find('save-price').text(salePrice);

    var totalCarat = caratValue;
    $productCard.find('.subtitle-product .carat_data').text(totalCarat.toFixed(2) + ' Total Carat');
    $productCard.find('.saving-badge').text(discountPrice);

    var allVaratData = $productCard.find('a.custom-jj-swatch-card.is-selected').attr('allmetaldata').split('|');
    allVaratData.forEach(function(data) {
        var parts = data.split(':');
        if (caratValue === parseFloat(parts[0])) {
            $productCard.find('.product-card__figure a, .product-card__title a, .personalise-btn').attr("href", parts[1]);
            $productCard.find('.text-on-sale').text(parts[2]);
            $productCard.find('.compare-at-price').text(parts[3]);
        }
    });
});

  
  $('.carat_var_value.selected').each(function(){
      var getCurrentPCardVarPrice = $(this).attr('va_price');
      var getCurrentPCardVarCompPrice = $(this).attr('va_compare_price');
      var getCurrentPCardDiscVarPrice = $(this).attr('va_discount_price');
      var getCurrentPCardDiscVarSale = $(this).attr('va_sale');
      var getCurrentPCardVarCaratValue = $(this).attr('va_carat');
      var getCurrentPCardVarSideValue = $(this).attr('va_side');
      var getCurrentPCardVarCaratId = $(this).attr('v_id');
      var getCurrentPCardVarHandle = $(this).attr('handle');
      var getSelectedSlideNumber = $(this).attr('item_number');
      $(this).parent().find('.selected').removeClass('selected');
      $(this).addClass('selected');
      var getExistingUrl = $('product-card[handle="'+getCurrentPCardVarHandle+'"] a.product_link_carat').attr('href');
      $('product-card[handle="'+getCurrentPCardVarHandle+'"]').find('sale-price').text(getCurrentPCardVarPrice);
      $('product-card[handle="'+getCurrentPCardVarHandle+'"]').find('compare-at-price').text(getCurrentPCardVarCompPrice);
      $('product-card[handle="'+getCurrentPCardVarHandle+'"]').find('new-price').text(getCurrentPCardDiscVarPrice);
      $('product-card[handle="'+getCurrentPCardVarHandle+'"]').find('save-price').text(getCurrentPCardDiscVarSale);
                  var caratValue = parseFloat(getCurrentPCardVarCaratValue);
                  var sideValue = parseFloat(getCurrentPCardVarSideValue);
                  // Check if sideValue is a number. If not, don't add it to caratValue.
                  var totalCarat = caratValue;
                  totalCarat = parseFloat(totalCarat.toFixed(2));
    $('product-card[handle="' + getCurrentPCardVarHandle + '"]').find('.subtitle-product .carat_data').text(totalCarat + ' Total Carat');
    $('product-card[handle="'+getCurrentPCardVarHandle+'"]').find('.saving-badge').text(getCurrentPCardDiscVarPrice);
  });

$(function() {
    // Function to update the product card based on the selected swatch
    function updateProductCard($swatchCard, $productCard) {
        var allVaratData = $swatchCard.attr('allmetaldata').split('|');
        var caratValue = parseFloat($productCard.find('.collection_var_carat label.selected').attr('va_carat'));
        allVaratData.forEach(function(data) {
            var parts = data.split(':');
            if (caratValue === parseFloat(parts[0])) {
                $productCard.find('.product-card__figure a, .product-card__title a').attr("href", parts[1]);
                $productCard.find('.text-on-sale').text(parts[2]);
                $productCard.find('.compare-at-price').text(parts[3]);
            }
        });
    }

    $(document).on('click', '.custom-jj-swatch-card', function() {
        var $swatchCard = $(this);
        var $productCard = $swatchCard.closest('.product-card'); // Use closest to find the nearest parent matching the selector

        // Update product card based on the selected swatch
        updateProductCard($swatchCard, $productCard);

        var src = $swatchCard.attr("variant-image");
        var plink = $swatchCard.attr("link-href");

        $swatchCard.siblings('.custom-jj-swatch-card').removeClass('is-selected');
        $swatchCard.addClass('is-selected');
        $productCard.find('.product-card__figure img').attr("src", src).attr("srcset", src);
        $productCard.find('.jj_metal_style_title').text($swatchCard.attr("variant-title"));
        $productCard.find('.product-card__figure a, .product-card__title a').attr("href", plink);
    });
});

document.addEventListener('DOMContentLoaded', function () {
  // Define the mapping between metal parameter and variant-title value
  const metalToVariantTitle = {
    '14k-white': '14K White Gold',
    '14k-rose': '14K Rose Gold',
    '18k-white': '18K White Gold',
    '18k-yellow': '18K Yellow Gold',
    'platinum': 'Platinum'
  };

  // Function to handle clicking the correct color swatch based on the metal parameter in the URL
  function clickSwatchBasedOnMetalParam() {
    // Get the 'filter.metal' parameter from the current URL
    const urlParams = new URLSearchParams(window.location.search);
    const selectedMetal = urlParams.get('filter.metal');

    // If the metal parameter is present in the URL and matches a variant-title, trigger click events
    if (selectedMetal && metalToVariantTitle[selectedMetal]) {
      const variantTitle = metalToVariantTitle[selectedMetal];

      // Find all elements with class '.color-swatch' and the matching 'variant-title' attribute
      const matchingElements = document.querySelectorAll(`.color-swatch[variant-title="${variantTitle}"]`);

      // Trigger click event on each matching element
      matchingElements.forEach(element => {
        element.click();
      });

      // Update all .active-facets elements with the selected metal name
      addRemovableFacetToActiveFacets(selectedMetal);
    }
  }

  // Function to add a new .removable-facet element to all .active-facets elements
  function addRemovableFacetToActiveFacets(selectedMetal) {
    // Find all .active-facets elements
    const activeFacets = document.querySelectorAll('.active-facets');

    activeFacets.forEach(facetContainer => {
      // Create the .removable-facet element with the metal name
      const removableFacet = document.createElement('div');
      removableFacet.classList.add('removable-facet', 'rounded-full');
      removableFacet.setAttribute('aria-controls', 'facets-drawer'); // Add the aria-controls attribute

      const hStack = document.createElement('div');
      hStack.classList.add('h-stack', 'gap-1');
      hStack.textContent = metalToVariantTitle[selectedMetal];

      // Append the hStack div to the removableFacet div
      removableFacet.appendChild(hStack);

      // Append the new removableFacet to each activeFacet without removing existing elements
      facetContainer.appendChild(removableFacet);
    });
  }

  // Check on page load if the metal exists in the URL params
  clickSwatchBasedOnMetalParam();

  // Listen for the custom 'facet:update' event
  document.addEventListener('facet:update', function () {
    // Add a delay to allow other scripts to finish, then click the matching swatches
    setTimeout(() => {
      clickSwatchBasedOnMetalParam();
    }, 2000); // 2 second delay (2000 milliseconds)
  });
});

let lastUrl = window.location.href;

const checkUrlChange = () => {
    if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;

        // Click on all elements with the .carat_var_value.selected class
        const selectedCaratElements = document.querySelectorAll('.carat_var_value.selected');
        selectedCaratElements.forEach(function (element) {
            element.click();
        });
    }
};

// Check for URL changes every second
setInterval(checkUrlChange, 2000);

